<router-outlet></router-outlet>
<lynx-modal></lynx-modal>
<lynx-loading-modal></lynx-loading-modal>
